import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, ButtonGroup, useTheme } from '@mui/material';
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { SORT_BY_OPTIONS } from '@verantos-dev/core-annotation-tool';
import { getTabStyle } from '@verantos-dev/core-annotation-tool';
import { Button } from '@verantos-dev/shared-components';

import { useSortBySection } from './useSortBySection';

export const SortBySection = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const { noteSortBy, handleNoteSortByChange } = useSortBySection();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
      <Typography variant="body1" sx={{ fontWeight: '500' }}>
        {formatMessage({ id: 'workspaceCommon.sidebar.viewOptions.sortBy.title' })}
      </Typography>
      <Box>
        <ButtonGroup
          color="inherit"
          orientation="horizontal"
          variant="contained"
          sx={{ width: '100%', borderRadius: 0 }}
        >
          {SORT_BY_OPTIONS.map((option: string) => (
            <Button
              startIcon={
                option === 'ascending' ? (
                  <ArrowUpwardIcon />
                ) : option === 'descending' ? (
                  <ArrowDownwardIcon />
                ) : null
              }
              key={`sort-by-button-${option}`}
              id={`sort-by-button-${option}`}
              displayLabel={formatMessage({
                id: `workspaceCommon.sidebar.viewOptions.sortBy.${option}`,
              })}
              sx={getTabStyle(option, noteSortBy, theme)}
              onClickHandler={() => handleNoteSortByChange(option)}
            />
          ))}
        </ButtonGroup>
      </Box>
    </Box>
  );
};
